import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import defaultStyles from '../DefaultStyles';
import breakpoints from '../../breakpoints';

import WeddingDate from './Components/WeddingDate';

const Container = styled.div`
  background-color: #ffffffd9;
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  a {
    font-family: ${defaultStyles.flower.bodyFont};
    font-weight: bold;
  }
`;

const WeddingTitle = styled.div`
  text-align: center;
  margin-top: 20px;
  margin-bottom: 0;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  font-size: 40px !important;
  font-family: ${defaultStyles.flower.headerFont} !important;
  color: ${defaultStyles.flower.colors.primary.base} !important;
  font-weight: normal;
  line-height: 1.25;
  @media (max-width: ${breakpoints.xs}), (max-height: ${breakpoints.xs}) {
    font-size: 25px !important;
    line-height: 1.2;
  }
`;

const CustomLogo = styled.div`
  height: 100px;
  width: 300px;
  margin: 9px auto;
  max-width: 100%;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

const StyledWeddingDate = styled(WeddingDate)`
  font-size: 15px !important;
  text-align: center;
  position: relative;
  bottom: 0 !important;
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
`;

const FlowerMenuContainer = ({ weddingId, weddingConfig, closeDrawer, children }) => {
  const { nameOfBride, nameOfGroom, weddingDate } = weddingConfig;
  return (
    <Container>
      <StyledNavLink to={{ pathname: `/${weddingId}/` }} onClick={() => closeDrawer()}>
        {weddingConfig.useCustomLogo ? (
          <CustomLogo imageUrl={weddingConfig.customLogoUrl}></CustomLogo>
        ) : (
          <>
            {weddingConfig && nameOfGroom && nameOfBride && (
              <>
                <WeddingTitle>
                  {nameOfBride} <br></br> &amp; <br></br> {nameOfGroom}
                </WeddingTitle>
                <StyledWeddingDate>{weddingDate}</StyledWeddingDate>
              </>
            )}
          </>
        )}
      </StyledNavLink>

      <div>{children}</div>
    </Container>
  );
};

export default FlowerMenuContainer;
